module.exports = __webpack_public_path__ + "img/Helfer_Peer.4f271f0b.svg";